
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.13 13l14.56.32c.48 0 1.54-.21 1.8.36a6.83 6.83 0 01.14 1.87l.7 9 .3 3.81a4.34 4.34 0 01-.13 2.32c-.56 1.07-1.55 1-2.56 1l-3.61-.08-9.09-.2h-2a2.21 2.21 0 01-2-2.68c.29-2.88.7-5.75 1.05-8.61l.59-4.85c0-.36 0-2.18.56-2.24a.81.81 0 10-.15-1.62c-1.38.15-1.84 1.18-2 2.37l-.54 3.83-1.18 9.65a12.55 12.55 0 00-.22 2.45A3.7 3.7 0 0012 33c2.61.14 5.23.11 7.84.17s5.1.16 7.65.17a3.89 3.89 0 004-3.24 11.37 11.37 0 00-.09-2.4l-.79-9.7-.3-3.81c-.09-1.13-.38-2.2-1.71-2.4a17 17 0 00-2.14-.06l-4.63-.11L13 11.4h-.55c-1.07-.04-1.45 1.6-.32 1.6z"}}),_c('path',{attrs:{"d":"M25.7 15.11v-4a6.22 6.22 0 00-.14-1.72 5.14 5.14 0 00-1.87-2.76C20.08 3.88 14 6.88 14 11.39v4.47c0 .15 1.64-.23 1.64-.75v-3.6-1.36A4.81 4.81 0 0117 7.33c1.47-1.45 3.92-.93 5.36.31A5 5 0 0124 10.35a6.27 6.27 0 01.1 1.44v4.07c0 .15 1.63-.23 1.63-.75z"}})])
          )
        }
      }
    